import React from 'react';
import { useTab } from 'context/restaurant/TabContext';
import TabSelectionScreen from './screens/TabSelectionScreen';
import MenuBrowserScreen from './screens/MenuBrowserScreen';

export default function WaiterFlow() {
    const { activeTab } = useTab();
    return activeTab ? <MenuBrowserScreen /> : <TabSelectionScreen />;
}
